import { createContext, useContext, useState } from "react";
import axios from "axios";

const TechnicalSnapshotContext = createContext();

export const TechnicalSnapshotProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [technicalSnapshot, setTechnicalSnapshot] = useState(null);
  const [technicalLoading, setTechnicalLoading] = useState(false);
  const [technicalError, setTechnicalError] = useState(null);

  const resetTechnicalSnapshot = () => {
    setTechnicalSnapshot(null);
    setTechnicalError(null);
    setTechnicalLoading(false);
  };
  //   const getTechnicalSnapshot = async (symbol) => {
  //     if (!symbol) return null;

  //     try {
  //       setTechnicalLoading(true);
  //       setTechnicalError(null);

  //       const res = await axios.get(
  //         `${BASE_URL}/api/technical-snapshot/${symbol}`,
  //       );

  //       setTechnicalSnapshot(res.data.data);
  //       return res.data.data;
  //     } catch (error) {
  //       console.error(
  //         "Technical snapshot error:",
  //         error.response?.data || error.message,
  //       );

  //       setTechnicalError(
  //         error.response?.data?.message || "Failed to fetch technical snapshot",
  //       );

  //       return null;
  //     } finally {
  //       setTechnicalLoading(false);
  //     }
  //   };

  const getTechnicalSnapshot = async (symbol) => {
    if (!symbol) return null;

    try {
      setTechnicalLoading(true);
      setTechnicalError(null);

      const res = await axios.get(
        `${BASE_URL}/api/technical-snapshot/${symbol}`,
      );

      setTechnicalSnapshot(res.data.data);
      console.log("Res data from technical", res.data);

      return res.data.data;
    } catch (error) {
      console.error(
        "Technical snapshot error:",
        error.response?.data || error.message,
      );

      setTechnicalError(
        error.response?.data?.message || "Failed to fetch technical snapshot",
      );

      return null;
    } finally {
      setTechnicalLoading(false);
    }
  };
  const initializeTechnicalSnapshot = async ({ symbol, securityId }) => {
    try {
      setTechnicalLoading(true);
      setTechnicalError(null);

      const res = await axios.post(`${BASE_URL}/api/technical-snapshot/init`, {
        symbol,
        securityId,
      });

      setTechnicalSnapshot(res.data.data);

      return res.data.data;
    } catch (error) {
      setTechnicalError(
        error.response?.data?.message || "Failed to initialize technical data",
      );

      return null;
    } finally {
      setTechnicalLoading(false);
    }
  };
  return (
    <TechnicalSnapshotContext.Provider
      value={{
        technicalSnapshot,
        technicalLoading,
        technicalError,
        getTechnicalSnapshot,
        initializeTechnicalSnapshot,
        resetTechnicalSnapshot,
      }}
    >
      {children}
    </TechnicalSnapshotContext.Provider>
  );
};

export const useTechnicalSnapshot = () => {
  return useContext(TechnicalSnapshotContext);
};
